import React, { useState } from 'react'
import { MasterSaleDetails } from './MasterSaleDetails';

export const MasterSale = ({masterSale}) => {

  return (
    <div style={{marginTop:20}}>
      <div style={{ fontSize: 20 }}>Compras</div>

      <MasterSaleDetails masterSale={masterSale} />
    </div>
  )
}
